module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 2_left_Light Blue.0b8c8307.svg";